import {UID_CUENTA_LIMPIEZA} from '../../utils/cuentaLimpieza';
import {InicioPanel} from './NavegacionPanel';
import {useAuth} from '../../context/AuthContext';
import PanelRolConfigurable from './PanelRolConfigurable';
// src/pages/roles/RoleShell.jsx
import React from 'react';
import '../login.css';
import './roles.css';

export function RoleLayout({ title, subtitle, roleLabel, children }) {const {profile}=useAuth();
  return (
    <div className="role-layout">
      <div className="role-card">
        <header className="role-card__header">
          <div>
            <p className="role-card__brand">PALMARAMA</p>
            <h1 className="role-card__title">{title}</h1>
            {subtitle && (
              <p className="role-card__subtitle">
                {subtitle}
              </p>
            )}
          </div>
          {roleLabel && (
            <div className="role-card__badge">
              {roleLabel}
            </div>
          )}
        </header>

        <div className="role-card__body">
          {profile&&(!['barra','porteria'].includes(profile.rol)||profile.id===UID_CUENTA_LIMPIEZA)?<InicioPanel profile={profile}/>:profile?.politicaRol?.panel?<PanelRolConfigurable profile={profile}/>:children}
        </div>


      </div>
    </div>
  );
}

export function RoleGrid({ children }) {
  return <div className="role-grid">{children}</div>;
}

export function RoleTile({ icon: Icon, label, description, onClick }) {
  return (
    <button className="role-tile" onClick={onClick} type="button">
      {Icon && (
        <div className="role-tile__icon">
          <Icon />
        </div>
      )}
      <div className="role-tile__text">
        <span className="role-tile__label">{label}</span>
        {description && (
          <span className="role-tile__desc">{description}</span>
        )}
      </div>
    </button>
  );
}

export default RoleLayout;
